"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EClienteEstadoCivil = exports.EClienteTipoPessoa = void 0;
var EClienteTipoPessoa;
(function (EClienteTipoPessoa) {
    EClienteTipoPessoa["Fisica"] = "0";
    EClienteTipoPessoa["Juridica"] = "1";
})(EClienteTipoPessoa = exports.EClienteTipoPessoa || (exports.EClienteTipoPessoa = {}));
var EClienteEstadoCivil;
(function (EClienteEstadoCivil) {
    EClienteEstadoCivil["Solteiro"] = "1";
    EClienteEstadoCivil["Casado"] = "2";
    EClienteEstadoCivil["Divorciado"] = "3";
    EClienteEstadoCivil["Vi\u00FAvo"] = "4";
})(EClienteEstadoCivil = exports.EClienteEstadoCivil || (exports.EClienteEstadoCivil = {}));
